import {
	alpha,
	Box,
	ButtonBase,
	Grid,
	Typography,
	useTheme,
} from "@mui/material";
import { useGoalCategoryLabels } from "web_myplann/Goals/Hooks/useGoalCategoryLabels";
import {
	GOAL_CATEGORY_CONFIG,
	SELECTABLE_GOAL_CATEGORIES,
} from "web_myplann/Goals/Types/GoalTypes";
import type { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	value: GoalCategoryTypeEnum | undefined;
	onChange: (next: GoalCategoryTypeEnum | undefined) => void;
	disabled?: boolean;
};

export const GoalCategorySelector = ({ value, onChange, disabled }: Props) => {
	const theme = useTheme();
	const categoryLabels = useGoalCategoryLabels();

	return (
		<Box px={1.6} py={1.2} bgcolor={theme.palette.background.paper}>
			<Grid container spacing={1}>
				{SELECTABLE_GOAL_CATEGORIES.map((category) => {
					const config = GOAL_CATEGORY_CONFIG[category];
					const Icon = config.icon;
					const selected = value === category;

					return (
						<Grid key={category} size={4}>
							<ButtonBase
								disabled={disabled}
								onClick={() =>
									onChange(value === category ? undefined : category)
								}
								sx={{
									width: "100%",
									flexDirection: "column",
									gap: 0.6,
									py: 1.2,
									borderRadius: theme.radii.lg,
									border: theme.colors.border.solid(
										selected
											? theme.palette.primary.main
											: theme.palette.grey[200],
									),
									bgcolor: selected
										? alpha(theme.palette.primary.main, 0.08)
										: theme.palette.background.paper,
									opacity: disabled && !selected ? 0.45 : 1,
									transition: "all 120ms ease-out",
								}}
							>
								<Box
									width={32}
									height={32}
									borderRadius={theme.radii.lg}
									bgcolor={config.bgColor}
									display="flex"
									alignItems="center"
									justifyContent="center"
								>
									<Icon size={18} color={config.color} />
								</Box>
								<Typography variant="button" color={theme.palette.grey[700]}>
									{categoryLabels[category]}
								</Typography>
							</ButtonBase>
						</Grid>
					);
				})}
			</Grid>
		</Box>
	);
};
